import { createContext, useContext } from 'react';

export type DateRange = '7d' | '30d' | '90d' | 'all';
export type Granularity = 'D' | 'W' | 'M';

export interface MeasurementFilters {
  range: DateRange;
  granularity: Granularity;
  modelId: string | null;
  topicId: string | null;
  tagId: string | null;
}

export interface MeasurementFilterCtx extends MeasurementFilters {
  startDate: string;
  endDate: string;
  setRange: (r: DateRange) => void;
  setGranularity: (g: Granularity) => void;
  setModelId: (id: string | null) => void;
  setTopicId: (id: string | null) => void;
  setTagId: (id: string | null) => void;
}

export const FilterContext = createContext<MeasurementFilterCtx | null>(null);

export function useFilters(): MeasurementFilterCtx {
  const ctx = useContext(FilterContext);
  if (!ctx) throw new Error('useFilters must be used inside <MeasurementShell>');
  return ctx;
}

export function dateRangeToDays(r: DateRange): number {
  if (r === '7d') return 7;
  if (r === '30d') return 30;
  if (r === '90d') return 90;
  return 365;
}

export function rangeToDates(r: DateRange): { startDate: string; endDate: string } {
  const end = new Date();
  const start = new Date();
  start.setDate(start.getDate() - dateRangeToDays(r));
  return {
    startDate: start.toISOString().split('T')[0]!,
    endDate: end.toISOString().split('T')[0]!,
  };
}

export function shiftDate(iso: string, days: number): string {
  const d = new Date(iso);
  d.setDate(d.getDate() + days);
  return d.toISOString().split('T')[0]!;
}
